
import AppMobileFullScreenContainer from "@/components/common/MobileFullScreenContainer.vue";
import AppToolbar from "@/components/common/ToolbarBase.vue";
import { DossierConfigService } from "@/services/dossier-config-service";
import Vue from "vue";
import { IBreadCrumb } from "winfakt-vue-components";
import AppPluginUblSettings from "./PluginUblSettingsGeneral.vue";
import AppPluginUblEmailSettings from "./PluginUblSettingsEmail.vue";
import AppPluginPeppolSettings from "./PluginUblSettingsPeppol.vue";
import AppUblOverview from "@/components/bookkeeping/UblOverview.vue";

export default Vue.extend({
	data() {
		return {
			settings: DossierConfigService.getPluginConfig(),
			activeTab: 0
		};
	},
	computed: {
		path(): IBreadCrumb[] {
			return [
				{
					to: "/settings", value: this.$ct("general")
				},
				{
					value: this.$ct("ubl")
				}
			] as IBreadCrumb[];
		},
		tabs(): any {
			return this.$ct("ubl-tabs");
		},
	},
	methods: {
		async savePluginConfig() {
			await DossierConfigService.savePluginConfig(this.settings);
			this.$wf.notify(this.$ct("save-success").toString(), "success", 3000, "check");
		},
		async save() {
			await DossierConfigService.savePluginConfig(this.settings);
			this.$wf.notify(this.$ct("save-success").toString(), "success", 3000, "check");
			this.$router.push("/settings");
		}
	},
	created(){
		if (this.$route.query.tab == "peppol"){
			this.activeTab = 1;
		}
	},
	components: {
		AppMobileFullScreenContainer,
		AppToolbar,
		AppPluginUblSettings,
		AppPluginPeppolSettings,
		AppPluginUblEmailSettings,
		AppUblOverview
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	},
});
